module.exports = __webpack_public_path__ + "img/Arabic-03.b70062c9.jpg";